import dynamic from 'next/dynamic';

import { getLazyHydrateTools } from '@/core/lazyHydrate/lazyHydrateTool';
import { Skeleton } from '@/core/tamagoshi/Skeleton/Skeleton';
import { CarbonScoreDetailProps } from '@/sustainability/carbonScore/components/CarbonScoreDetail/CarbonScoreDetail';

const { dynamicOptions, makeLazyHydrated } =
  getLazyHydrateTools<CarbonScoreDetailProps>({
    id: 'CarbonScoreDetail.lazy',
    on: 'visible',
    placeholder: <Skeleton width="100%" height="426px" />,
  });

const DynamicCarbonScoreDetail = dynamic<CarbonScoreDetailProps>(
  () =>
    import(
      '@/sustainability/carbonScore/components/CarbonScoreDetail/CarbonScoreDetail'
    ).then((mod) => mod.CarbonScoreDetail),
  { ...dynamicOptions },
);

export const CarbonScoreDetail = makeLazyHydrated(DynamicCarbonScoreDetail);
